import { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";
import axios from "axios";
import FestivalBasketPanel, { useBasket } from "@/components/FestivalBasketPanel";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function FestivalBasketButton() {
  const [pricing, setPricing] = useState(null);
  const [open, setOpen] = useState(false);
  const basket = useBasket(pricing);

  useEffect(() => {
    axios.get(`${BACKEND}/api/festival/pricing`)
      .then((r) => setPricing(r.data.pricing))
      .catch(() => setPricing(null));
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="mine-basket-btn"
        className="relative inline-flex items-center gap-1 px-3 py-2 text-xs uppercase tracking-wider border border-[#262626] hover:border-[#CCFF00] hover:text-[#CCFF00] transition-colors"
      >
        <ShoppingCart className="w-4 h-4" />
        Basket
        {basket.items.length > 0 && (
          <span className="ml-1 min-w-[18px] px-1 h-[18px] text-[10px] font-bold rounded-full bg-[#CCFF00] text-black inline-flex items-center justify-center" data-testid="mine-basket-count">
            {basket.items.length}
          </span>
        )}
      </button>
      <FestivalBasketPanel pricing={pricing} basket={basket} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
